import useActionCondition from "security-app/components/Investigations/plugin/useActionCondition";
export const isNotSystemEvent = (event) => !event.event_definition_type.startsWith("system-notifications");
const useEventActionCondition = (events) => {
  const hasNonSystemEvents = !!events.filter(isNotSystemEvent).length;
  return useActionCondition() && hasNonSystemEvents;
};
export default useEventActionCondition;
